import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import { getFAQItemIcon } from 'lib/cruises/cruiseIcons'
import Accordion from 'LuxKit/Accordion'

const BulletList = styled(BodyText)`
  list-style: disc;

  > * + li {
    margin-top: ${rem(16)};
  }

  strong {
    font-size: ${rem(16)};
    display: block;
    margin-bottom: ${rem(-8)};
  }

  b {
    font-weight: ${props => props.theme.font.primary.weight.bold};
  }

  a {
    text-decoration: underline;
  }
`

interface Props {
  FAQItem: App.CruiseFAQ
}

function CruiseFAQItem(props: Props) {
  const { FAQItem } = props
  const { content, title, key } = FAQItem

  const Icon = getFAQItemIcon(key)

  return (
    <Accordion
      heading={title}
      startIcon={<Icon aria-hidden="true" />}
      size="large"
    >
      <BulletList forwardedAs="ul" variant="medium" weight="normal">
        {content.map((item, index) => <li key={`${item}${index}`} dangerouslySetInnerHTML={{ __html: item }}></li>)}
      </BulletList>
    </Accordion>
  )
}

export default memo(CruiseFAQItem)
